(() => {
  'use strict';

  if (window.theme?.productVariantGalleryInitialized) return;

  window.theme = window.theme || {};
  window.theme.productVariantGalleryInitialized = true;

  const selectors = {
    productInfo: 'product-info',
    productImages: 'product-images',
    productMedia: '[data-image-id]',
    productMediaList: '[data-product-media-list]',
  };

  const getGallerySignature = (gallery) => {
    const activeMedia = gallery.getAttribute('data-active-media') || '';
    const mediaIds = [...gallery.querySelectorAll(selectors.productMedia)].map((media) => media.getAttribute('data-media-id')).join('|');

    return `${activeMedia}:${mediaIds}`;
  };

  subscribe(theme.PUB_SUB_EVENTS.variantChange, (event = {}) => {
    const {data} = event;
    const sectionId = data?.sectionId;
    const html = data?.html;

    if (!sectionId || !html) return;

    const currentProduct = document.querySelector(`${selectors.productInfo}[data-section="${sectionId}"]`);
    const nextProduct = html.querySelector(`${selectors.productInfo}[data-section="${sectionId}"]`);

    if (!currentProduct || !nextProduct) return;

    const currentGallery = currentProduct.querySelector(selectors.productImages);
    const nextGallery = nextProduct.querySelector(selectors.productImages);

    if (!currentGallery || !nextGallery) return;
    if (getGallerySignature(currentGallery) === getGallerySignature(nextGallery)) return;

    currentGallery.replaceWith(nextGallery);
    currentProduct.productImages = nextGallery;
    currentProduct.productMediaList = nextGallery.querySelector(selectors.productMediaList);
  });
})();
